import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/Auth.module";
import UserModule from "./modules/User.module";
import ConfigModule from "./modules/Config.module";
import CompanyModule from "./modules/Company.module";
import GameModule from "./modules/Game.module";
import TypeModule from "./modules/Type.module";
import GameQuestion from "./modules/GameQuestion.module";
import GameLogModule from "./modules/GameLog.module";
import OrganizationModule from "./modules/Organization.module";
import TagModule from "./modules/Tag.module";
import MediaModule from "src/packages/gallery/Media.module";
import CurrentOrg from "./modules/CurrentOrg.module";
import UpdateModule from "./modules/Update.module";
import QuestionModule from "root/packages/closeapp/QuestionsManager/assets/store/Question.module";

Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		loading: false
	},
	modules: {
		AuthModule,
		UserModule,
		ConfigModule,
		CompanyModule,
		QuestionModule,
		GameModule,
		CurrentOrg,
		TypeModule,
		GameQuestion,
		GameLogModule,
		TagModule,
		OrganizationModule,
		UpdateModule,
		MediaModule
	}
});
export default store;

export const config = function (key, value) {
	store.commit(ConfigModule.types.SET, {key, value});
};
window.cc = config;
